module.exports = __webpack_public_path__ + "img/1457133435.4db47699.jpg";